var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loader-wrapper",class:{ show: _vm.showLoader }},[_c('div',{staticClass:"page-loader"}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b',[_vm._v("Loading")]),_vm._v("This should take a second ")])
}]

export { render, staticRenderFns }